import React, { useEffect } from "react";
import { useRecaptcha } from "../../../utils/useRecaptcha";

const RecaptchaLoginWrapper = ({ children, onLogin }) => {
  const { loadRecaptchaScript, cleanupRecaptcha } = useRecaptcha();

  useEffect(() => {
    loadRecaptchaScript();

    return () => {
      cleanupRecaptcha();
    };
  }, [loadRecaptchaScript, cleanupRecaptcha]);

  return <>{children}</>;
};

export default RecaptchaLoginWrapper;
